import { render, staticRenderFns } from "./turnOverTeam.vue?vue&type=template&id=7ca368f1&scoped=true"
import script from "./turnOverTeam.vue?vue&type=script&lang=js"
export * from "./turnOverTeam.vue?vue&type=script&lang=js"
import style0 from "./turnOverTeam.vue?vue&type=style&index=0&id=7ca368f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca368f1",
  null
  
)

export default component.exports